
import BeautySection from '../components/BeautySection';
import FooterSection from '../components/FooterSection';
import ProductCards from '../components/ProductCards';
function Home() {
  
    return (
      <div className="">
       
        <BeautySection />
        <ProductCards />
        <FooterSection />
      </div>
    );
  }
  
  export default Home;